/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

document.addEventListener( 'DOMContentLoaded', () => {
  const geoLocation = {
    nz: {
      url: 'https://moccamaster-nz.myshopify.com/',
      message: '<p>Visitors from the Land of the Long White Cloud please refer our Moccamaster NZ website</p>'
    }
  };

  if( !sessionStorage.getItem( 'country-code' ) ) {
    $.getJSON( 'https://api.db-ip.com/v2/free/self', function( data ) {
      const countryCode = data.countryCode.toLowerCase();
      console.log( 'Code: ' + countryCode );

      // Save so we don't have to fetch every time
      sessionStorage.setItem( 'country-code', countryCode );

      // const countryCode = 'au';
      if( geoLocation[countryCode] ) {
        // Update text
        const message = document.querySelector( '.geolocation-message' );
        if( message ) {
          if( message.querySelector( '.message' ) ) {
            message.querySelector( '.message' ).innerHTML = geoLocation[countryCode].message;
          }
          if( message.querySelector( 'a.c-btn' ) ) {
            message.querySelector( 'a.c-btn' ).href = geoLocation[countryCode].url;
          }
        }
  
        // Show banner
        if( document.body ) {
          document.body.classList.add( 'show-geolocation-message' );
        }
      }
    } );

  }
  

  document.querySelectorAll( '.geolocation-message .close' ).forEach( ( link ) => {
    link.addEventListener( 'click', ( e ) => {
      e.preventDefault();
      document.body.classList.remove( 'show-geolocation-message' );
    } );
  } );

  // Reverse image to product select
  const allProducts = ( document.getElementById( 'ProductJson-1' ) ) ? JSON.parse( document.getElementById( 'ProductJson-1' ).innerHTML ) : [];

  if( document.querySelector( '.product-single__photos' ) ) {
    document.querySelector( '.product-single__photos' ).addEventListener( 'click', ( e ) => { // Buttons are generated on load so can't be targeted consistently directly
      console.log( e.target );
      if( e.target.classList.contains( 'product-single__photo-thumbs__img') || e.target.tagName == 'BUTTON' ) {
        const img = ( e.target.tagName == 'IMG' ) ? e.target : e.target.querySelector( 'img' ); // Select image if this isn't already it
        if( img ) {
          const mediaId = img.dataset['mediaId']; // ID for image
          const newVarient = allProducts.variants.filter( ( varient ) => { // Find in product list
            return varient.featured_media.id == mediaId;
          } );
          if( newVarient.length > 0 ) { // If a product is returned click it's button
            // Use class*= to cover colours and swatches
            if( document.querySelector( 'input[class*=product-single__][value="' + newVarient[0].title + '"]' ) ) {
              document.querySelector( 'input[class*=product-single__][value="' + newVarient[0].title + '"]' ).click();
            }
          }
        }
      }
    } );
  }
} );

